export default __webpack_public_path__ + "static/media/pn.9e3f2ec7.svg";